import styled from 'styled-components';
import React from 'react';
import Link from 'next/link.js';
import { Img } from '@/src/components/common/ui/images/Img.jsx';
import reactHtmlParser from 'react-html-parser';
import { devices, theme } from '@/styles/theme/index.jsx';

const CategorySingle = ({ mainImage, hoverImage, title, link }) => {
	return (
		<StyledCategorySingle className="single-item-logo-partners">
			<Link href={link || '/'}>
				<div className="single-item-category">
					<div className="image-wrapper">
						<Img alt={reactHtmlParser(title)} src={mainImage} />
						<Img alt={reactHtmlParser(title)} src={hoverImage ? hoverImage : mainImage} />
						<div className="title-category">
							<h5>{reactHtmlParser(title)}</h5>
						</div>
					</div>
				</div>
			</Link>
		</StyledCategorySingle>
	);
};

const StyledCategorySingle = styled.div`
    .single-item-category {
        cursor: pointer;

        .image-wrapper {
            position: relative;
            padding-top: calc(550 / 345 * 100%);
            transition: ${theme.transition};

            .global-image {
                transition: ${theme.transition};

                &:nth-of-type(2) {
                    opacity: 0;
                }
            }

        }

        .title-category {
            h5 {
                color: ${theme.colors.white};
                font-weight: 600;
                font-size: 1.5rem;
                line-height: 1;
                letter-spacing: -0.03em;
            }

            text-align: center;
            position: absolute;
            bottom: 70px;
            left: 0;
            right: 0;
            @media (max-width: 992px) {
                bottom: 40px;
            }
        }

        &:hover {
            .image-wrapper {
                .global-image {
                    &:nth-of-type(1) {
                        opacity: 0;
                    }

                    &:nth-of-type(2) {
                        opacity: 1;
                    }
                }

            }

        }
    }

    ${devices.sm} {
        .single-item-category .title-category {
            bottom: 15px;

            h5 {
                font-weight: 600;
                font-size: 1rem; /* 16px */
                line-height: 1; /* 100% */
                letter-spacing: -0.03em; /* -3% of font-size */
                text-align: center;
            }
        }

    }


`;
export default CategorySingle;
